import { gql } from '@apollo/client';

export const UNITS_REPORT_QUERY = gql`
  query GetUnitsReport(
    $page: Int
    $limit: Int
    $term: String
    $nameFilter: String
    $legalNameFilter: String
    $accountManagerIdFilter: String
    $crmIdFilter: String
    $unitIdFilter: String
    $companyIdFilter: String
    $docNumberFilter: String
    $cityFilter: String
    $addressFilter: String
    $postalCodeFilter: String
    $installationCodeFilter: String
    $newInstallationCodeFilter: String
    $edcCustomerCodeFilter: String
    $assetCodeFilter: String
    $cceeProfileFilter: String
    $status: Int
    $submarket: Int
    $productType: Int
    $energyType: Int
    $unitType: Int
    $tariffSubgroup: Int
    $tariffModality: Int
    $energyContractingModel: Int
    $docType: Int
    $edc: Int
    $state: String
    $aclBefore2025Law: Boolean
    $aclBefore2025LawIsNull: Boolean
    $isNewConnection: Boolean
    $isNewConnectionIsNull: Boolean
    $powerGenerator: Boolean
    $powerGeneratorIsNull: Boolean
    $exposure: Int
    $volumeMwmMin: Float
    $volumeMwmMax: Float
    $exposurePercentageMin: Float
    $exposurePercentageMax: Float
    $managementCostMin: Float
    $managementCostMax: Float
    $demandPeakMin: Float
    $demandPeakMax: Float
    $demandOffPeakMin: Float
    $demandOffPeakMax: Float
    $demandPeakBeforeMin: Float
    $demandPeakBeforeMax: Float
    $demandOffPeakBeforeMin: Float
    $demandOffPeakBeforeMax: Float
    $demandPeakBeforeLawMin: Float
    $demandPeakBeforeLawMax: Float
    $demandOffPeakBeforeLawMin: Float
    $demandOffPeakBeforeLawMax: Float
    $generatorCostMin: Float
    $generatorCostMax: Float
    $migrationDateFrom: String
    $migrationDateTo: String
    $expectedMigrationDateFrom: String
    $expectedMigrationDateTo: String
    $clientSinceFrom: String
    $clientSinceTo: String
    $churnDateFrom: String
    $churnDateTo: String
    $createdAtFrom: String
    $createdAtTo: String
    $updatedAtFrom: String
    $updatedAtTo: String
    $sortBy: String
    $sortOrder: String
    $nullKpi: String
  ) {
    unitsReport(
      page: $page
      limit: $limit
      term: $term
      nameFilter: $nameFilter
      legalNameFilter: $legalNameFilter
      accountManagerIdFilter: $accountManagerIdFilter
      crmIdFilter: $crmIdFilter
      unitIdFilter: $unitIdFilter
      companyIdFilter: $companyIdFilter
      docNumberFilter: $docNumberFilter
      cityFilter: $cityFilter
      addressFilter: $addressFilter
      postalCodeFilter: $postalCodeFilter
      installationCodeFilter: $installationCodeFilter
      newInstallationCodeFilter: $newInstallationCodeFilter
      edcCustomerCodeFilter: $edcCustomerCodeFilter
      assetCodeFilter: $assetCodeFilter
      cceeProfileFilter: $cceeProfileFilter
      status: $status
      submarket: $submarket
      productType: $productType
      energyType: $energyType
      unitType: $unitType
      tariffSubgroup: $tariffSubgroup
      tariffModality: $tariffModality
      energyContractingModel: $energyContractingModel
      docType: $docType
      edc: $edc
      state: $state
      aclBefore2025Law: $aclBefore2025Law
      aclBefore2025LawIsNull: $aclBefore2025LawIsNull
      isNewConnection: $isNewConnection
      isNewConnectionIsNull: $isNewConnectionIsNull
      powerGenerator: $powerGenerator
      powerGeneratorIsNull: $powerGeneratorIsNull
      exposure: $exposure
      volumeMwmMin: $volumeMwmMin
      volumeMwmMax: $volumeMwmMax
      exposurePercentageMin: $exposurePercentageMin
      exposurePercentageMax: $exposurePercentageMax
      managementCostMin: $managementCostMin
      managementCostMax: $managementCostMax
      demandPeakMin: $demandPeakMin
      demandPeakMax: $demandPeakMax
      demandOffPeakMin: $demandOffPeakMin
      demandOffPeakMax: $demandOffPeakMax
      demandPeakBeforeMin: $demandPeakBeforeMin
      demandPeakBeforeMax: $demandPeakBeforeMax
      demandOffPeakBeforeMin: $demandOffPeakBeforeMin
      demandOffPeakBeforeMax: $demandOffPeakBeforeMax
      demandPeakBeforeLawMin: $demandPeakBeforeLawMin
      demandPeakBeforeLawMax: $demandPeakBeforeLawMax
      demandOffPeakBeforeLawMin: $demandOffPeakBeforeLawMin
      demandOffPeakBeforeLawMax: $demandOffPeakBeforeLawMax
      generatorCostMin: $generatorCostMin
      generatorCostMax: $generatorCostMax
      migrationDateFrom: $migrationDateFrom
      migrationDateTo: $migrationDateTo
      expectedMigrationDateFrom: $expectedMigrationDateFrom
      expectedMigrationDateTo: $expectedMigrationDateTo
      clientSinceFrom: $clientSinceFrom
      clientSinceTo: $clientSinceTo
      churnDateFrom: $churnDateFrom
      churnDateTo: $churnDateTo
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
      updatedAtFrom: $updatedAtFrom
      updatedAtTo: $updatedAtTo
      sortBy: $sortBy
      sortOrder: $sortOrder
      nullKpi: $nullKpi
    ) {
      page
      total
      limit
      indicators {
        totalUnits
        totalVolumeMwm
        nullKpis {
          name
          legalName
          status
          edc
          productType
          energyType
          submarket
          state
          unitType
          tariffSubgroup
          tariffModality
          energyContractingModel
          volumeMwm
          exposure
          exposurePercentage
          managementCost
          demandPeakBlue
          demandOffPeak
          demandPeakBeforeBlue
          demandOffPeakBefore
          demandPeakBeforeLawBlue
          demandOffPeakBeforeLaw
          generatorCost
          migrationDate
          expectedMigrationDate
          aclBefore2025Law
          city
          address
          postalCode
          docType
          docNumber
          installationCode
          newInstallationCode
          edcCustomerCode
          assetCode
          crmId
          cceeProfile
          isNewConnection
          powerGenerator
        }
      }
      data {
        id
        companyId
        name
        legalName
        unitType
        tariffSubgroup
        tariffModality
        contractedDemandPeak
        contractedDemandOffPeak
        contractedDemandPeakBeforeMigration
        contractedDemandOffPeakBeforeMigration
        contractedDemandPeakBeforeLaw
        contractedDemandOffPeakBeforeLaw
        migrationDate
        expectedMigrationDate
        churnDate
        clientSince
        aclBefore2025Law
        edc {
          id
        }
        state
        city
        fullTextAddress
        postalCode
        docType
        docNumber
        productType
        energyType
        submarket
        energyContractingModel
        cceeProfile {
          id
          idCcee
          name
        }
        assetCode
        cceeMeasuringPoint
        installationCode
        newInstallationCode
        edcCustomerCode
        isNewConnection
        powerGenerator
        generatorCost
        status
        volumeMwm
        exposure
        exposurePercentage
        managementCost
        createdAt
        updatedAt
        organizationId
      }
    }
  }
`;

export const UNITS_REPORT_FILTER_VALUES_QUERY = gql`
  query GetUnitsReportFilterValues($field: String!) {
    unitsReportFilterValues(field: $field) {
      values
      hasEmpty
    }
  }
`;
